<template>
  <Layout>
    <div class="tabs-container">
      <div
          class="tab"
          :class="{ active: isActiveTab === 0 }"
          @click="switchTab(0)"
      >
        <span>{{$t("all_posts")}}</span>
      </div>
      <div
          class="tab"
          :class="{ active: isActiveTab === 1 }"
          @click="switchTab(1)"
      >
        <span>{{$t("reported_posts")}}</span>
      </div>
    </div>

    <div class="table-holder" v-if="isActiveTab === 0">
      <SocialTable :loading="isLoading" :users="tableData.data" :refreshData="() => loadData(currentPage)" />
      <div class="pagination-align-center">
        <Pagination
            :total-items="tableData.pagination?.totalRecords || 0"
            :per-page="20"
            :current-page="currentPage"
            :on-page-change="handlePage"
        />
      </div>
    </div>
    <div class="table-holder" v-else>
      <ReportedUsersTable :loading="isLoading" :users="tableData.data" :refreshData="() => loadData(currentPage)" />
      <div class="pagination-align-center">
        <Pagination
            :total-items="tableData.pagination?.totalRecords || 0"
            :per-page="20"
            :current-page="currentPage"
            :on-page-change="handlePage"
        />
      </div>
    </div>

  </Layout>
</template>

<script>
import BarChart from '@/components/charts/BarChart.vue'
import Layout from "@/components/layouts/Layout.vue";
import AvatarArray from "@/components/AvatarArray.vue";
import SocialTable from "@/components/tables/Social/GamificationTable.vue";
import socialService from "@/service/socialService";
import Pagination from "@/components/Pagination.vue";
import CompanyTable from "@/components/tables/Company/CompanyTable.vue";
import {handleErrorResponse} from "@/utils/utils";
import roleService from "@/service/roleService";
import GamificationTasks from "@/components/gamification/GamificationTasks.vue";
import ReportedUsersTable from "../components/tables/Social/ReportedUsersTable.vue";

export default {
  name: 'Social',
  components: {
    GamificationTasks,
    CompanyTable,
    Pagination,
    SocialTable,
    ReportedUsersTable,
    AvatarArray,
    Layout,
    BarChart,
  },
  data() {
    return {
      isLoading: true,
      tableData: {},
      currentPage: 1,
      roleList: [],
      isActiveTab: 0
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    }
  },
  methods: {
    switchTab(tabIndex) {
      this.isActiveTab = tabIndex;
      this.currentPage = 1; // Tab değiştiğinde sayfayı sıfırla
      this.loadData(1);
    },

    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;
      this.currentPage = page;
      this.loadData(page);
    },

    loadData(page) {
      this.isLoading = true;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      // Tab durumuna göre farklı API çağır
      if (this.isActiveTab === 0) {
        // Tüm Gönderiler
        socialService.getPosts(page, tempFilters).then(response => {
          this.tableData = response.data;
          console.log('gelen tableData (getPosts) : ', this.tableData);
          this.isLoading = false;
        }).catch(err => {
          handleErrorResponse(err, this.$snackbar);
          this.isLoading = false;
        });
      } else {
        // Şikayet Edilen Gönderiler
        socialService.getReportedPosts(page, tempFilters).then(response => {
          this.tableData = response.data;
          console.log('gelen tableData (getReportedPosts) : ', this.tableData);
          this.isLoading = false;
        }).catch(err => {
          handleErrorResponse(err, this.$snackbar);
          this.isLoading = false;
        });
      }
    },

    handleEditTask(task) {
      this.$snackbar.add({
        text: `Düzenleniyor: ${task.name}`,
        type: 'info'
      });
    }
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem('user'));
    roleService.getStoreByCompanyRole(user.companyId).then(response => {
      this.roleList = response.data.data;
    }).catch(err => {
      handleErrorResponse(err, this.$snackbar);
    });

    // Sayfa yüklendiğinde ilk tab (Tüm Gönderiler) verisini yükle
    this.loadData(1);
  }
}
</script>

<style scoped>
.icon-title span {
  font-family: 'euclid_medium', sans-serif;
  font-size: 18px;
  white-space: nowrap
}

.icon-holder img {
  cursor: default;
}
.table-holder {
  margin-top: 20px;
}
.table-holder .table {
  margin-top: 20px;
}
.tabs-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.tab {
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #667085;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}

.tab.active {
  border-bottom: 2px solid #4A68F8;
  color: #4A68F8;
}

.tasks-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.tasks-title {
  font-size: 20px;
  font-weight: 600;
  color: #101828;
}

.add-task-btn {
  display: flex;
  align-items: center;
  background-color: #0044FF;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-task-btn img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.add-task-btn:hover {
  background-color: #0036CC;
}
</style>
